<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="false"
                @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.keywords" placeholder="分类名称" style="width: 260px"></Input>
        </FormItem>
      </template>

      <template slot="avatar" slot-scope="{ row }">
        <Avatar :src="row.avatar"></Avatar>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Poptip
          confirm
          title="确定要删除吗?"
          placement="left"
          @on-ok="btnHandler('delete', row)"
          @on-cancel="btnHandler('cancel', row)">
          <Button type="warning" size="small" icon="md-trash"></Button>
        </Poptip>
      </template>
    </page-table>
    <Drawer v-model="detailDrawer.show" :title="detailDrawer.title"  :mask-closable="false" width="1000">
      <detail :id="detailDrawer.id"></detail>
    </Drawer>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import Detail from '../member/components/detail'
import { getMemberList } from '../../api/member'

export default {
  name: 'member-list',
  components: { Detail, pageTable },
  data () {
    return {
      params: {
        keywords: '',
        register_date: []
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      detailDrawer: {
        show: false,
        loading: false,
        title: '',
        id: 0
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: 'id', key: 'id', width: 60 },
        { title: '分类名称', key: 'avatar', slot: 'avatar', width: 60 },
        { title: '创建时间', key: 'username' },
        { title: '操作', slot: 'action', width: 100, fixed: 'right', align: 'center' }
      ]
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getMemberList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    detail (row) {
      this.detailDrawer.show = true
      this.detailDrawer.id = row.id
      this.detailDrawer.title = row.username + '-会员详情'
    },
    delete (row) {
      deleteMember({ id: row.id }).then(res => {
        this.$Message.info('删除成功')
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>

</style>
